module.exports = __webpack_public_path__ + "img/no-chain-link2-01.4c2ae562.svg";